import { FullscreenSpinner, isWeb, YStack } from "@medbillai/ui";
import { BackgroundRadialGrantedGradient } from "../../../../components/BackgroundRadialGrantedGradient";
import { type InsuranceLinks, LoadingStatus } from "../../utils/useNormalizedEobs";
import { EmptyConnectedBlock } from "./EmptyConnectedBlock";
import { InsuranceLinkingBlock } from "./InsuranceLinkingBlock";
import { NoInsuranceBlock } from "./NoInsuranceBlock";
export interface EmptyBillListProps {
  filter: string;
  insuranceLinks: InsuranceLinks;
  loading: boolean;
}
export const EmptyBillList = ({
  filter,
  insuranceLinks,
  loading
}: EmptyBillListProps) => {
  const isInsuranceLinked = insuranceLinks.length > 0;
  const linksProcessing = insuranceLinks.some(link => link.status === LoadingStatus.IN_PROGRESS);
  return <YStack testID="bills.empty-state" jc="center" ai="center" f={1} gap="$4" height="100%" mt={isWeb ? "$-15" : "$0"} pt="$4" minHeight={200} data-sentry-element="YStack" data-sentry-component="EmptyBillList" data-sentry-source-file="EmptyBillList.tsx">
      <BackgroundRadialGrantedGradient opacity={emptyGradientOpacity({
      isInsuranceLinked: isInsuranceLinked,
      linksProcessing: linksProcessing
    })} fullscreen={false} objectFit="cover" data-sentry-element="BackgroundRadialGrantedGradient" data-sentry-source-file="EmptyBillList.tsx" />
      {loading ? <FullscreenSpinner /> : <EmptyBlockWrapper selectedFilter={filter} isInsuranceLinked={isInsuranceLinked} linksProcessing={linksProcessing} />}
    </YStack>;
};
const EmptyBlockWrapper = ({
  linksProcessing,
  isInsuranceLinked,
  selectedFilter
}: {
  linksProcessing: boolean;
  isInsuranceLinked: boolean;
  selectedFilter: string;
}) => {
  if (linksProcessing) {
    return <InsuranceLinkingBlock />;
  }
  if (isInsuranceLinked) {
    return <EmptyConnectedBlock selectedFilter={selectedFilter} />;
  }
  return <NoInsuranceBlock selectedFilter={selectedFilter} data-sentry-element="NoInsuranceBlock" data-sentry-component="EmptyBlockWrapper" data-sentry-source-file="EmptyBillList.tsx" />;
};
const emptyGradientOpacity = ({
  linksProcessing,
  isInsuranceLinked
}: {
  linksProcessing: boolean;
  isInsuranceLinked: boolean;
}) => {
  if (linksProcessing) {
    return 0;
  }
  if (isInsuranceLinked) {
    return 0;
  }
  return 1;
};